<ce-template-header-scroll
    [scrollId]="scrollId"
    [infiniteScrollContainer]="infiniteScrollContainer"
    (scrolledDown)="getMoreNotifications()"
    ceDocumentResizeObserver
    (documentResizeEvent)="onScreenResize($event)"
>
    <div slot="header">
        <ce-breadcrumb [breadcrumbRoutes]="[]" class="u-hide-gt-sm u-spacing-lg-mv" />
        <div class="flex-row flex-between u-spacing-lg-mv">
            <h1 class="u-text-title-sm">Notifications</h1>
            <div>
                <button ce-button-small ce-button-type-tertiary ce-button-icon [ceContextMenuTriggerFor]="actions" [ceContextMenuPosition]="'bottom-right'">
                    <ce-icon svgIcon="more" />
                </button>

                <ce-context-menu #actions>
                    <ce-list size="sm">
                        <button
                            type="button"
                            class="ce-button-bare"
                            (click)="updateReadStatusAll(true)"
                            [disabled]="notifications().length === 0 || this.unreadCounts()?.[this.notificationStatus()]?.sent === 0"
                        >
                            <ce-list-option [disabled]="notifications().length === 0 || this.unreadCounts()?.[this.notificationStatus()]?.sent === 0">
                                <ce-icon ce-list-option-prefix svgIcon="envelope" ce-icon-sm />
                                Mark all as read
                            </ce-list-option>
                        </button>
                        <button
                            type="button"
                            class="ce-button-bare"
                            (click)="updateReadStatusAll(false)"
                            [disabled]="notifications().length === 0 || this.unreadCounts()?.[this.notificationStatus()]?.read === 0"
                        >
                            <ce-list-option [disabled]="notifications().length === 0 || this.unreadCounts()?.[this.notificationStatus()]?.read === 0">
                                <ce-icon ce-list-option-prefix svgIcon="envelope-unread" ce-icon-sm />
                                Mark all as unread
                            </ce-list-option>
                        </button>
                        @if (notificationStatus() !== 'archived') {
                        <button
                            type="button"
                            class="ce-button-bare"
                            (click)="updateArchivedStatusAll(true)"
                            [disabled]="notifications().length === 0 || (this.unreadCounts()?.inbox?.sent === 0 && this.unreadCounts()?.inbox?.read === 0)"
                        >
                            <ce-list-option [disabled]="notifications().length === 0 || (this.unreadCounts()?.inbox?.sent === 0 && this.unreadCounts()?.inbox?.read === 0)">
                                <ce-icon ce-list-option-prefix svgIcon="archive" ce-icon-sm />
                                Archive all
                            </ce-list-option>
                        </button>
                        } @if (notificationStatus() !== 'inbox') {
                        <button
                            type="button"
                            class="ce-button-bare"
                            (click)="updateArchivedStatusAll(false)"
                            [disabled]="notifications().length === 0 || (this.unreadCounts()?.archived?.sent === 0 && this.unreadCounts()?.archived?.read === 0)"
                        >
                            <ce-list-option [disabled]="notifications().length === 0 || (this.unreadCounts()?.archived?.sent === 0 && this.unreadCounts()?.archived?.read === 0)">
                                <ce-icon ce-list-option-prefix svgIcon="unarchive" ce-icon-sm />
                                Unarchive all
                            </ce-list-option>
                        </button>
                        }
                        <a routerLink="/profile-settings/notification-settings/" class="u-color-text-primary u-text-decoration-none">
                            <ce-list-option>
                                <ce-icon ce-list-option-prefix svgIcon="settings" ce-icon-sm />
                                Settings
                            </ce-list-option>
                        </a>
                    </ce-list>
                </ce-context-menu>
            </div>
        </div>
        <div class="u-border-bottom-secondary u-hide-lt-sm">
            <ce-tab-group [tabs]="tabs" [tabIndex]="tabIndexFromRoute()" [countHasLoaded]="!!unreadCounts()" tabType="section" elementType="anchor" class="u-spacing-sm-mh" />
        </div>
        <ce-tab-group [tabs]="tabs" [tabIndex]="tabIndexFromRoute()" [countHasLoaded]="!!unreadCounts()" tabType="page" elementType="anchor" class="u-hide-gt-sm" />
    </div>
    <div slot="scroll">
        @if (hasLoaded() && notifications().length === 0) {
        <ce-empty-state size="md" type="notification" [actionLabel]="emptyStateData().actionLabel" [actionHref]="emptyStateData().actionHref">
            <h2 ce-empty-state-title>{{ emptyStateData().heading }}</h2>
            <p ce-empty-state-description>{{ emptyStateData().description }}</p>
        </ce-empty-state>
        } @else {
        <ce-notification-list
            [hasLoaded]="hasLoaded()"
            [notificationData]="notifications()"
            (notificationSelected)="selectNotificationById($event)"
            [notificationIdSelected]="selectedNotificationId()"
            [showGuidanceAtEnd]="wasLastPage && getMoreNotificationsTriggered"
            [firstItemLoading]="newNotificationLoading()"
        ></ce-notification-list>
        }
    </div>
</ce-template-header-scroll>
